import { Locale } from '@finxone-platform/shared/enums';
import { AlertTypes, NotificationTemplateEnum } from '@finxone-platform/shared/sys-config-types';

export const profileSmsTranslations = {
  [Locale.en_GB]: {
    INDIVIDUAL_PROFILE_UPDATE_TITLE: 'Your profile details were updated',
    INDIVIDUAL_PROFILE_UPDATE_DESCRIPTION: '',
    BUSINESS_PROFILE_UPDATE_TITLE: 'Details Updated',
    BUSINESS_PROFILE_UPDATE_DESCRIPTION: 'Your business profile details have been updated successfully.',
  },
  // Add more locales as needed
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const generateProfileSmsAlerts = (translations: any) => ({
  [NotificationTemplateEnum.INDIVIDUAL_PROFILE_UPDATE]: {
    name: 'Individual Profile Update',
    type: AlertTypes.INFO,
    title: translations.INDIVIDUAL_PROFILE_UPDATE_TITLE,
    description: translations.INDIVIDUAL_PROFILE_UPDATE_DESCRIPTION,
  },
  [NotificationTemplateEnum.BUSINESS_PROFILE_UPDATE]: {
    name: 'Business Profile Update',
    type: AlertTypes.INFO,
    title: translations.BUSINESS_PROFILE_UPDATE_TITLE,
    description: translations.BUSINESS_PROFILE_UPDATE_DESCRIPTION,
  },
});
